module.exports = require("./es-BR.d.ts");